import React from "react";
import { AlertTriangle } from "lucide-react";

/** Reusable AI disclaimer note — surfaced anywhere AI-generated content is shown to staff. */
export default function AiDisclaimer({ compact = false, className = "" }) {
  if (compact) {
    return (
      <p data-testid="ai-disclaimer" className={`text-[11px] leading-snug text-[#8a6d1f] flex items-start gap-1.5 ${className}`}>
        <AlertTriangle size={12} className="mt-0.5 shrink-0" />
        AI aid only — may be incomplete or incorrect. Review before acting. Not medical, legal, financial, tax, or real-estate advice.
      </p>
    );
  }
  return (
    <div data-testid="ai-disclaimer" className={`rounded-lg border border-[#EADFBF] bg-[#FBF7EC] px-3 py-2 text-[12px] leading-relaxed text-[#8a6d1f] flex items-start gap-2 ${className}`}>
      <AlertTriangle size={14} className="mt-0.5 shrink-0" />
      <span><strong>AI summaries are a staff aid only.</strong> They may be incomplete or incorrect and do not replace professional judgment. Staff must review before acting. This is not medical, legal, financial, tax, or real-estate advice.</span>
    </div>
  );
}
